export const RESET_ALL_ACCOUNT_STATE_DEPEN = "RESET_ALL_ACCOUNT_STATE_DEPEN";
export const SET_GLOBAL_VALUE = "SET_GLOBAL_VALUE";
export const OPPS_CLEAN_UP = "OPPS_CLEAN_UP";

export const resetAllAccDepen = () => {
  return (dispatch) => {
    dispatch({
      type: RESET_ALL_ACCOUNT_STATE_DEPEN
    });
  };
};

export const resetAllOppsReducer= () => {
  return (dispatch) => {
    dispatch({
      type: OPPS_CLEAN_UP
    });
  };
};

export const setGlobalValue = (value) => {
  return (dispatch) => {
    dispatch({
      type: SET_GLOBAL_VALUE,
      payload: value,
    });
  };
};